export default __webpack_public_path__ + "static/media/588.cfc1b2af.png";